import React from 'react';
import P from '@hero/ui-kit/typography/P';

import { relatedConditions } from '../conditions';
import * as Style from '../style.module.scss';
import { CareRow } from '../types';

const RelatedConditions: React.FC<{ row: CareRow; patientRows: CareRow[] }> = ({ row, patientRows }) => {
    const conditions = relatedConditions(row, patientRows);
    return (
        <div className={Style.codeConditions}>
            {conditions.items.length ? (
                <>
                    <P size="small" strong noDefaultMargin>Related conditions</P>
                    {conditions.items.map((item) => (
                        <P key={item} size="small" noDefaultMargin>{item}</P>
                    ))}
                </>
            ) : null}
            <P size="small" noDefaultMargin className={Style.codeProgram}>{conditions.message}</P>
        </div>
    );
};

export default RelatedConditions;
